module.exports = __webpack_public_path__ + "static/img/kxqm.7725c83.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/course/kxqm.jpg
// module id = ph++
// module chunks = 0